import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingWaterMitigationSystem = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.waterMitigationSystem' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.waterMitigationDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.sumpPumpType' />}
                    value={props.waterMitigationSystem?.sumpPumpType}
                    references={props.reference.references?.SumpPumpType}
                    referencesEvent={() => props.reference.doGetReferences('SumpPumpType')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}sumpPumpType`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.backupValveType' />}
                    value={props.waterMitigationSystem?.backupValveType}
                    references={props.reference.references?.SewerBackupValve}
                    referencesEvent={() => props.reference.doGetReferences('SewerBackupValve')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}backupValveType`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.auxiliaryPower' />}
                    value={
                        props.waterMitigationSystem && {
                            code: convertFromBoolean(props.waterMitigationSystem.auxiliaryPower),
                        }
                    }
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}auxiliaryPower`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.connectedToAlarm' />}
                    value={
                        props.waterMitigationSystem && {
                            code: convertFromBoolean(props.waterMitigationSystem.connectedToAlarm),
                        }
                    }
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}connectedToAlarm`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
                {props.allowPrimary && (
                    <FormRadio
                        label={<FormattedMessage id='Profile_Dwellings_WaterMitigationSystem.primary' />}
                        value={
                            props.waterMitigationSystem && {
                                code: convertFromBoolean(props.waterMitigationSystem.primary),
                            }
                        }
                        references={props.reference.references?.YesNo}
                        referencesEvent={() => props.reference.doGetReferences('YesNo')}
                        changeEvent={(value) =>
                            props.doReducePolicyElement({
                                code: `${props.dotProp}primary`,
                                value: convertToBoolean(value.code),
                            })
                        }
                        allowEdit
                    />
                )}
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingWaterMitigationSystem;
